export default "__VITE_ASSET__165b4ad5__"